export const dev = {
    auth0: {
        domain: 'dev-crew-time.eu.auth0.com',
        clientId: 'QVx2Rp8r6TciRlPvXKTwjTpImQmBcFhT',
        audience: 'https://crew-time/api',
    }
}

export const prod = {
    auth0: {
        domain: 'dev-crew-time.eu.auth0.com',
        clientId: 'QVx2Rp8r6TciRlPvXKTwjTpImQmBcFhT',
        audience: 'https://crew-time/api',
    }
}